//
// Autoplay Manager
//
// Contains functions and calls to manage the autoplay dialog and autoplay functionality

autoplayManager = {};
autoplayManager.containerName = 'autoplayBackground';
autoplayManager.AP = gdk.getAutoplayObject();

autoplayManager.initialise = function () {
  // Autoplay manager only works if there is an autoplay container defined
  if (!resourceManager.hasResource(autoplayManager.containerName)) {
    return;
  }

  autoplayManager.callbacks = {};

  // Get all objects on the autoplay dialog
  autoplayManager.dialog = {};
  autoplayManager.dialog.container = resourceManager.get(autoplayManager.containerName);
  if (typeof resourceManager.containers['autoplayContainer'] !== 'undefined') {
    resourceManager.getContainer('autoplayContainer').visible = true;
  }

  autoplayManager.dialog.cancelButton = resourceManager.get(autoplayManager.containerName + ':autoplayCancel');
  autoplayManager.dialog.OKButton = resourceManager.get(autoplayManager.containerName + ':autoplayOK');
  // Number of spins
  autoplayManager.dialog.NOSprev = resourceManager.get(autoplayManager.containerName + ':autoplayNOSprev');
  autoplayManager.dialog.NOSnext = resourceManager.get(autoplayManager.containerName + ':autoplayNOSnext');
  autoplayManager.dialog.NOStext = resourceManager.get(autoplayManager.containerName + ':autoplayNOStext');
  // Loss Limit
  autoplayManager.dialog.LLprev = resourceManager.get(autoplayManager.containerName + ':autoplayLLprev');
  autoplayManager.dialog.LLnext = resourceManager.get(autoplayManager.containerName + ':autoplayLLnext');
  autoplayManager.dialog.LLtext = resourceManager.get(autoplayManager.containerName + ':autoplayLLtext');
  // Single win limit
  autoplayManager.dialog.SWLprev = resourceManager.get(autoplayManager.containerName + ':autoplaySWLprev');
  autoplayManager.dialog.SWLnext = resourceManager.get(autoplayManager.containerName + ':autoplaySWLnext');
  autoplayManager.dialog.SWLtext = resourceManager.get(autoplayManager.containerName + ':autoplaySWLtext');

  // Map buttons to function
  autoplayManager.dialog.NOSprev.onPressedCallback = autoplayManager.onNOSprev;
  autoplayManager.dialog.NOSnext.onPressedCallback = autoplayManager.onNOSnext;
  autoplayManager.dialog.LLprev.onPressedCallback = autoplayManager.onLLprev;
  autoplayManager.dialog.LLnext.onPressedCallback = autoplayManager.onLLnext;
  autoplayManager.dialog.SWLprev.onPressedCallback = autoplayManager.onSWLprev;
  autoplayManager.dialog.SWLnext.onPressedCallback = autoplayManager.onSWLnext;

  autoplayManager.dialog.cancelButton.enableButton(true);
  autoplayManager.dialog.NOSprev.enableButton(true);
  autoplayManager.dialog.NOSnext.enableButton(true);
  autoplayManager.dialog.LLprev.enableButton(true);
  autoplayManager.dialog.LLnext.enableButton(true);
  autoplayManager.dialog.SWLprev.enableButton(true);
  autoplayManager.dialog.SWLnext.enableButton(true);

  // Hide dialog by default
  autoplayManager.dialog.container.visible = false;

  messageBus.subscribe('stake:stakeChanged', autoplayManager.changeStake);
};

autoplayManager.changeStake = function (selectedStake) {
  autoplayManager.stake = selectedStake;
};

autoplayManager.getRemainingRounds = function () {
  return autoplayManager.AP.roundsRemaining();
};

autoplayManager.fadeInDialog = function (progress) {
  autoplayManager.dialog.container.alpha = progress;
};

autoplayManager.fadeInDialogCompete = function () {
  // Enable buttons
  autoplayManager.dialog.OKButton.onPressedCallback = autoplayManager.onOK;
  autoplayManager.dialog.cancelButton.onPressedCallback = autoplayManager.onCancel;

  autoplayManager.dialog.container.alpha = 1;
};

autoplayManager.fadeOutDialog = function (progress) {
  autoplayManager.dialog.container.alpha = 1 - progress;
};

autoplayManager.fadeOutDialogCancelled = function () {
  autoplayManager.dialog.container.visible = false;
  autoplayManager.dialog.container.alpha = 1;

  autoplayManager.callbacks.cancel();
};

autoplayManager.fadeOutDialogAccepted = function () {
  autoplayManager.dialog.container.visible = false;
  autoplayManager.dialog.container.alpha = 1;

  // Now we have left dialog, start autoplay
  autoplayManager.AP.start(autoplayManager.stake);
  autoplayManager.callbacks.OK();
  gdk.startAutoplay();
};

autoplayManager.openDialog = function (confirmCallback, cancelCallback, coinSize, numberOfWinlines) {
  // Coins is the cost of playing one winline
  if (coinSize !== undefined) {
    autoplayManager.stake = coinSize * numberOfWinlines;
  }
  /*
    // For screenshots in help pages!
    resourceManager.getContainer("gameContainer").visible = false;
    resourceManager.getContainer("backgroundContainer").visible = false;
    resourceManager.getContainer("buttonsContainer").visible = false;
    */

  autoplayManager.lossLimitSet = false;
  autoplayManager.dialog.OKButton.enableButton(false);

  // Fade in dialog
  autoplayManager.dialog.container.visible = true;
  autoplayManager.dialog.container.alpha = 0;
  timerManager.addTimer(300, autoplayManager.fadeInDialog, autoplayManager.fadeInDialogCompete);

  autoplayManager.dialog.OKButton.onPressedCallback = function () {};
  autoplayManager.dialog.cancelButton.onPressedCallback = function () {};

  // Store callbacks
  autoplayManager.callbacks.OK = confirmCallback;
  autoplayManager.callbacks.cancel = cancelCallback;

  // Reset autoplay settings
  autoplayManager.AP.reset();

  autoplayManager.dialog.NOStext.text = autoplayManager.AP.fields['numberOfRounds'].currentValue;
  autoplayManager.dialog.LLtext.setTranslationPhrase('t_autoplayPleaseSet');
  autoplayManager.dialog.SWLtext.setTranslationPhrase(autoplayManager.getSWLtext());
};

autoplayManager.getLLtext = function () {
  if (autoplayManager.AP.fields['lossLimit'].currentValue === -1) {
    return 't_autoplayNoLimit';
  }

  return gdk.formatCurrency(autoplayManager.AP.fields['lossLimit'].currentValue * autoplayManager.stake);
};

autoplayManager.getSWLtext = function () {
  if (autoplayManager.AP.fields['singleWinLimit'].currentValue === -1) {
    return 't_autoplayNoLimit';
  }

  return gdk.formatCurrency(autoplayManager.AP.fields['singleWinLimit'].currentValue * autoplayManager.stake);
};

autoplayManager.isAutoplayEnabled = function () {
  if (autoplayManager.AP) {
    return autoplayManager.AP.isActive();
  }
  return false;
};

autoplayManager.canContinue = function () {
  return autoplayManager.AP.canContinue();
};

autoplayManager.stopAutoplay = function () {
  autoplayManager.AP.stop();
  gdk.stopAutoplay();
};

autoplayManager.onOK = function () {
  autoplayManager.dialog.OKButton.onPressedCallback = function () {};
  autoplayManager.dialog.cancelButton.onPressedCallback = function () {};

  soundManager.play('autoplayChing');
  timerManager.addTimer(200, autoplayManager.fadeOutDialog, autoplayManager.fadeOutDialogAccepted);
};

autoplayManager.onCancel = function () {
  autoplayManager.dialog.OKButton.onPressedCallback = function () {};
  autoplayManager.dialog.cancelButton.onPressedCallback = function () {};

  soundManager.play('autoplayCancel');
  timerManager.addTimer(200, autoplayManager.fadeOutDialog, autoplayManager.fadeOutDialogCancelled);
};

autoplayManager.updateOKButton = function () {
  autoplayManager.dialog.OKButton.enableButton(
    (autoplayManager.stake <= gdk.getBalance() || gdk.allowSpinIfNotEnoughCredit()) && autoplayManager.lossLimitSet
  );
};

autoplayManager.onNOSprev = function () {
  autoplayManager.playButtonSound();

  var data = autoplayManager.AP.fields['numberOfRounds'];
  var newIndex = data.values.indexOf(data.currentValue) - 1;
  if (newIndex < 0) {
    newIndex = data.values.length - 1;
  }

  autoplayManager.AP.setField('numberOfRounds', data.values[newIndex]);
  autoplayManager.dialog.NOStext.text = autoplayManager.AP.fields['numberOfRounds'].currentValue;
  autoplayManager.updateOKButton();
};

autoplayManager.onNOSnext = function () {
  autoplayManager.playButtonSound();

  var data = autoplayManager.AP.fields['numberOfRounds'];
  var newIndex = (data.values.indexOf(data.currentValue) + 1) % data.values.length;
  autoplayManager.AP.setField('numberOfRounds', data.values[newIndex]);
  autoplayManager.dialog.NOStext.text = autoplayManager.AP.fields['numberOfRounds'].currentValue;
  autoplayManager.updateOKButton();
};

autoplayManager.onLLprev = function () {
  autoplayManager.playButtonSound();

  var data = autoplayManager.AP.fields['lossLimit'];

  var newIndex = autoplayManager.lossLimitSet ? data.values.indexOf(data.currentValue) - 1 : data.defaultIndex;
  if (newIndex < 0) {
    newIndex = data.values.length - 1;
  }

  autoplayManager.lossLimitSet = true;
  autoplayManager.AP.setField('lossLimit', data.values[newIndex]);
  autoplayManager.dialog.LLtext.setTranslationPhrase(autoplayManager.getLLtext());
  autoplayManager.updateOKButton();
};

autoplayManager.onLLnext = function () {
  autoplayManager.playButtonSound();

  var data = autoplayManager.AP.fields['lossLimit'];
  var newIndex = autoplayManager.lossLimitSet
    ? (data.values.indexOf(data.currentValue) + 1) % data.values.length
    : data.defaultIndex;
  autoplayManager.lossLimitSet = true;
  autoplayManager.AP.setField('lossLimit', data.values[newIndex]);
  autoplayManager.dialog.LLtext.setTranslationPhrase(autoplayManager.getLLtext());
  autoplayManager.updateOKButton();
};

autoplayManager.onSWLprev = function () {
  autoplayManager.playButtonSound();

  var data = autoplayManager.AP.fields['singleWinLimit'];
  var newIndex = data.values.indexOf(data.currentValue) - 1;
  if (newIndex < 0) {
    newIndex = data.values.length - 1;
  }
  autoplayManager.AP.setField('singleWinLimit', data.values[newIndex]);
  autoplayManager.dialog.SWLtext.setTranslationPhrase(autoplayManager.getSWLtext());
};

autoplayManager.onSWLnext = function () {
  autoplayManager.playButtonSound();

  var data = autoplayManager.AP.fields['singleWinLimit'];
  var newIndex = (data.values.indexOf(data.currentValue) + 1) % data.values.length;
  autoplayManager.AP.setField('singleWinLimit', data.values[newIndex]);
  autoplayManager.dialog.SWLtext.setTranslationPhrase(autoplayManager.getSWLtext());
};

autoplayManager.playButtonSound = function () {
  soundManager.stop('buttonPressed');
  soundManager.play('buttonPressed');
};

autoplayManager.onModal = function (msg) {
  // is something takes us out of modal but we are still visible, keep modal
  // For example, history will cause Gati wrapper to pause our game and resume when history closed.
  // Resume will clear modal but this settings menu is still open allowing the player to spin behind the settings menu
  if (autoplayManager.dialog.container.visible && msg.reason === undefined) {
    messageBus.post('game:modal', {
      reason: 'Autoplay open',
      data: 'autoplayManager - Autoplay open',
    });
  }
};

Reflex.registerInitialiseManager(autoplayManager.initialise);
